import { forwardRef, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { Message } from '~extension/web2print/view/MessageModal/Message';
import { Button } from '~modules/media-library/view/Button';

type MessageModalPanelProps = {
  onClose?: () => void;
  message: string;
};

export const MessageModalPanel = forwardRef<HTMLDivElement, JSX.IntrinsicElements['div'] & MessageModalPanelProps>(
  function MessageModalPanel({ onClose, message, className, ...TheirProps }, ref) {
    return (
      <div
        className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg min-h-0 max-h-full flex flex-col relative ${
          className ? className : ''
        }`}
        {...TheirProps}
        ref={ref}
      >
        <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
          <CloseIcon />
        </Button>
        <Message message={message} />
      </div>
    );
  },
);
